import type { TranscriptLine } from "./types";

/** Same seq replaces in place (a partial becoming final). New seq appends. */
export function mergeLiveLine(lines: TranscriptLine[], incoming: TranscriptLine): TranscriptLine[] {
  const idx = lines.findIndex((l) => l.seq === incoming.seq);
  if (idx === -1) return [...lines, incoming];
  const next = lines.slice();
  next[idx] = incoming;
  return next;
}
